module.exports = __webpack_public_path__ + "img/footer_home--disabled.55e3b665.svg";